import { ColorClassification } from '../../../../products/product.types.v2';
import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterByColorClassifications extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
    info,
  }: OrderProductsSorterSortParams<T>): T[] {
    const classificationTypeId = info?.classificationTypeId?.[0] || '';

    const { classificationGroups, noClassificationItems } = orderProducts.reduce(
      (acc, product) => {
        let hasClassification = false;

        product.colorClassifications?.forEach((classification: ColorClassification) => {
          if (classification.classificationType.id === classificationTypeId) {
            hasClassification = true;
            if (!acc.classificationGroups[classification.id]) {
              acc.classificationGroups[classification.id] = [];
            }
            acc.classificationGroups[classification.id].push(product);
          }
        });

        if (!hasClassification) {
          acc.noClassificationItems.push(product);
        }

        return acc;
      },
      {
        classificationGroups: {} as { [classificationId: string]: T[] },
        noClassificationItems: [] as T[],
      },
    );

    const sortedItems: T[] = Object.keys(classificationGroups)
      .sort()
      .flatMap((classificationId) => classificationGroups[classificationId]);

    sortedItems.push(...noClassificationItems);

    return sortedItems;
  }
}

export default OrderProductsSorterByColorClassifications;
